import Vue from 'vue';

Vue.component('new-cancelled-order', () =>
    import(/* webpackChunkName: 'cancelled-order' */ './cancelled-order.vue'),
);
